export const intensityTypes = {
    STANDART: 0,
    BRONZE: 1,
    SILVER: 2,
    GOLD: 3,
    STAR: 4,
    SUPERSTAR: 5,
}